var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(" "+_vm._s(`Запросить код повторно через ${_vm.timeLeftString || '...'}`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }